import { settings } from '@/_config';

import AtpCharLogoIcon from './assets/atp-char-logo.svg?react';
import AtpTwoLinerFullLogo from './assets/atp-two-liner-full-logo.svg?react';
import SwaCharLogoIcon from './assets/swa-char-logo.svg?react';
import SWATwoLinerFullLogo from './assets/swa-two-liner-full-logo.svg?react';

export function Logo() {
  return settings.isSWA ? (
    <SWATwoLinerFullLogo width={199} height={55} />
  ) : (
    <AtpTwoLinerFullLogo width={163} height={53} />
  );
}

export function NavbarLogo({ margin = 14, ...props }) {
  console.log(margin);
  return settings.isSWA ? <SwaCharLogoIcon {...props} width="56px" /> : <AtpCharLogoIcon {...props} />;
}
